import * as React from "react";
import { useState, useEffect, useMemo } from "react";
import styled, { css } from "styled-components";
import { Icon } from "components/common";
import { DropdownMenu } from "security-app/components/common";
import { GLCheckbox } from "common/components";
import { MenuItem } from "components/bootstrap";
import DateFilter from "views/components/widgets/overview-configuration/filters/DateFilter";
const FilterTrigger = styled.span(
  ({ $open, theme }) => css`
    cursor: pointer;
    position: relative;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
    color: ${theme.colors.text.primary};

    & > svg {
      transition: rotate 0.2s;
      rotate: ${$open ? 180 : 0}deg;
    }
  `
);
const FilterItem = styled.div(
  ({ theme }) => css`
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;

    font-weight: normal;
    color: ${theme.colors.text.primary};
  `
);
const ColumnFilter = ({ filterBy, filterData, appliedFilters, type, onClose, children }) => {
  const [open, setOpen] = useState(false);
  const [filterValues, setFilterValues] = useState(appliedFilters[filterBy] || []);
  useEffect(() => {
    setFilterValues(appliedFilters[filterBy] || []);
  }, [filterBy, appliedFilters]);
  const closeMenu = () => {
    onClose(filterBy, filterValues.length > 0 ? filterValues : null);
  };
  const filterIncluded = (fData) => !!filterValues.find(({ value }) => value === fData.value);
  const onFilterChange = (fData) => () => {
    if (filterIncluded(fData)) {
      setFilterValues(filterValues.filter(({ value }) => value !== fData.value));
    } else {
      setFilterValues([...filterValues, fData]);
    }
  };
  const onFilterDateChange = (values) => {
    setFilterValues(
      values.map((value) => {
        var _a;
        return {
          label: value,
          value,
          type: "string",
          backend: filterData ? (_a = filterData[0]) == null ? void 0 : _a.backend : void 0
        };
      })
    );
  };
  const filterByType = () => {
    switch (type) {
      case "date":
        return /* @__PURE__ */ React.createElement(DateFilter, { values: filterValues.map(({ value }) => value), onChange: onFilterDateChange });
      default:
        return filterData.filter(({ value }) => !!value).map((fData) => /* @__PURE__ */ React.createElement(MenuItem, { key: `filter-${filterBy}-${fData.value}`, onClick: onFilterChange(fData) }, /* @__PURE__ */ React.createElement(FilterItem, null, /* @__PURE__ */ React.createElement(
          GLCheckbox,
          {
            onChange: onFilterChange(fData),
            checked: filterIncluded(fData),
            "aria-label": `filter-${fData.label}`
          }
        ), /* @__PURE__ */ React.createElement("span", { tabIndex: 0, role: "checkbox", "aria-checked": filterIncluded(fData), title: `filter-${fData.label}` }, fData.label))));
    }
  };
  const showFilters = useMemo(
    () => type === "text" && filterData && filterData.length > 1 || type === "date",
    [filterData, type]
  );
  return showFilters ? /* @__PURE__ */ React.createElement(
    DropdownMenu,
    {
      onClose: closeMenu,
      closeOnItemClick: false,
      trigger: /* @__PURE__ */ React.createElement(FilterTrigger, { $open: open, onClick: () => setOpen(!open) }, /* @__PURE__ */ React.createElement(Icon, { name: "keyboard_arrow_down", size: "xs" }), children)
    },
    filterByType()
  ) : /* @__PURE__ */ React.createElement("span", null, children);
};
export default ColumnFilter;
